// @flow
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import times from '../../../../data/times'
import Card from '../../../../components/Card'
import Button from '../../../../components/Button'
import InputGroup from '../../../../components/InputGroup'
import InputGroupAddon from '../../../../components/InputGroupAddon'

type Props = {
  onSubmit: Function,
  handleSubmit: Function
}

type State = {
  date: Date,
  focused: boolean
}

class TourMiniForm extends Component {
  constructor(props: Props) {
    super(props)
    this.state = {
      date: moment(),
      focused: false
    }
  }

  state: State
  props: Props

  handleSubmit = (data) =>
    this.props.onSubmit({ date: this.state.date, ...data })

  render() {
    const { handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Card style={{ marginBottom: '2rem' }}>
          <InputGroup style={{ marginBottom: '1rem' }}>
            <InputGroupAddon>
              <span className="fa fa-calendar" />
            </InputGroupAddon>
            <SingleDatePicker
              id="tourDate"
              style={{ width: '100%' }}
              numberOfMonths={1}
              date={this.state.date}
              focused={this.state.focused}
              onDateChange={(date) => {
                this.setState({ date })
              }}
              onFocusChange={({ focused }) => {
                this.setState({ focused })
              }}
            />
          </InputGroup>
          <InputGroup style={{ marginBottom: '1rem' }}>
            <InputGroupAddon>
              <span className="fa fa-clock-o" />
            </InputGroupAddon>
            <Field name="time" component="select" className="form-control">
              {times.map((time) => (
                <option key={time} value={time}>
                  {time}
                </option>
              ))}
            </Field>
          </InputGroup>
          <InputGroup style={{ marginBottom: '1rem' }}>
            <InputGroupAddon>
              <span className="fa fa-street-view" />
            </InputGroupAddon>
            <Field name="method" component="select" className="form-control">
              <option value="In Person">In Person</option>
              <option value="Virtual">Virtual</option>
            </Field>
          </InputGroup>
          <Button style={{ display: 'block', width: '100%' }}>
            Schedule Tour
          </Button>
        </Card>
      </form>
    )
  }
}

export default reduxForm({
  form: 'tourMini'
})(TourMiniForm)



// WEBPACK FOOTER //
// ./src/views/Property/components/TourMiniForm/index.js